module.exports = __webpack_public_path__ + "static/media/status-open.26d2026c.svg";